module.exports = __webpack_public_path__ + "media/images/home/postmates-868ab2e07df27368c1522bb36b723b41.png";